import React from 'react';

import bubbleInvalidSvg from '@assets/img/icons/bubble-invalid.svg';
import bubbleSvg from '@assets/img/icons/bubble.svg';
import { SpinnerModal } from '@components/SpinnerModal';
import { usePostZendeskTicket } from '@hooks/mutation/dashboard/usePostZendeskTicket';
import { ZendeskTicket } from '@models/Zendesk';
import { getConfig } from '@utils/config';
import { createStrings } from '@utils/local';

const strings = createStrings({
  ja: {
    confirmCreateTicket:
      'ユーザーとのZendesk Ticketはまだ作成されていません。Zendesk Ticketを作成しますか？',
  },
});

export const TicketBubble: React.FC<{
  userId: number;
  d2dNo: string;
  ticket?: ZendeskTicket;
}> = (props) => {
  const { userId, d2dNo, ticket } = props;

  const imgStyle: React.CSSProperties = {
    verticalAlign: 'bottom',
    marginLeft: '0.25rem',
    cursor: 'pointer',
  };

  const postZendeskTicket = usePostZendeskTicket(userId, d2dNo);

  return (
    <a
      style={{ display: 'contents' }}
      target="_blank"
      href={ticket && `${getConfig().zendeskDashboard}/agent/tickets/${ticket.id}`}
      onClick={async () => {
        if (!ticket && confirm(strings.confirmCreateTicket)) {
          const ticket = await postZendeskTicket.mutateAsync();
          window.open(`${getConfig().zendeskDashboard}/agent/tickets/${ticket.id}`);
        }
      }}
    >
      <SpinnerModal open={postZendeskTicket.isLoading} />

      {ticket === undefined && (
        <img alt="Ticket does not exist" src={bubbleInvalidSvg} style={imgStyle} />
      )}
      {ticket && <img alt="Ticket is created" src={bubbleSvg} style={imgStyle} />}
    </a>
  );
};
